var _rect, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgThree(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 59,
    viewBox: "0 0 59 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 59,
    height: 59,
    rx: 10,
    fill: "url(#paint0_linear_393_228)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4865 41.624C17.4065 45.848 22.0145 47.432 26.3345 47.48C32.6705 47.528 38.9105 43.784 39.8225 37.112C40.2065 34.472 39.6305 30.632 36.4625 28.856C40.2065 26.696 41.3105 22.04 40.2545 18.68V18.728C38.8145 14.36 35.0705 12.536 30.9425 12.536C26.8625 12.536 22.7345 14.552 19.4225 18.008L23.7905 22.424C25.1825 21.032 27.1985 20.264 28.8785 20.264C30.1265 20.264 31.1825 20.792 31.7105 21.8C32.4785 23.24 31.3265 26.024 29.1185 26.024H24.0305L23.0225 33.176H28.0145C30.4625 33.176 31.7585 34.712 31.5185 36.44C31.2785 38.264 29.0705 39.368 26.7665 39.368C24.7985 39.368 22.7345 38.456 21.7745 36.488L15.4865 41.624Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_393_228",
    x1: 29.5,
    y1: 59,
    x2: 29.5,
    y2: -0.00000158954,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35CB00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#75FF21"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgThree);
export default __webpack_public_path__ + "static/media/three.8c90314d0a18a221534b983ad5d08614.svg";
export { ForwardRef as ReactComponent };